import React from 'react'

function index() {
  return (
    <div>AddCourse</div>
  )
}

export default index